import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';
import { getPlanStage } from '../../../utils/productAccess';
import { Box, Typography, Grid } from '@mui/material';
import { TabbedOverviewPage, SectionHeader, NoteBanner } from '../components/OverviewSections.comp';

const NAVY = '#052F44';
const GREEN = '#1B6B55';

/* Slide 3 — How the COS Readiness Solution Works: From Baseline to Action to
   Verified Impact. */
const READINESS_STEPS = [
    {num: '1', title: 'COS Baseline', body: 'Measure your students’ online safety baseline through the COS assessment, covering online safety readiness, risk experiences, and context and support systems.'},
    {num: '2', title: 'Gap Diagnosis', body: 'Turn the results into priorities, so the weakest skills and items become a focused shortlist of where students need help most.'},
    {num: '3', title: 'Targeted Learning', body: 'Connect each priority to a concrete plan, pairing skill gaps with learning programs and broader needs with school or home support.'},
    {num: '4', title: 'Learning Impact', body: 'Track students’ real-time progress toward closing the priority gaps using pre and post evidence and activity evidence.'},
    {num: '5', title: 'COS Reassessment*', body: 'Repeat the COS assessment next cycle to verify which priority gaps have closed, so early progress becomes confirmed COS movement.'},
];

const ReadinessSolutionSection = () => (
    <Box>
        <SectionHeader
            title="How the COS Readiness Solution Works"
            subtitle="From Baseline to Action to Verified Impact"
        />

        <Grid container spacing={2.5} alignItems="stretch">
            {READINESS_STEPS.map((s, i) => (
                <Grid item xs={12} sm={6} md={2.4} key={s.num}>
                    <Box sx={{
                        position: 'relative', border: '1px solid var(--brand-border, #E5E7EB)', borderRadius: '12px',
                        backgroundColor: 'var(--brand-surface, #ffffff)', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', p: 3, height: '100%',
                    }}>
                        <Box sx={{
                            width: 34, height: 34, borderRadius: '50%', backgroundColor: GREEN,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1.5,
                        }}>
                            <Typography sx={{fontSize: '16px', fontWeight: 800, color: '#fff'}}>{s.num}</Typography>
                        </Box>
                        <Typography sx={{fontSize: '15px', fontWeight: 700, color: NAVY, mb: 0.5}}>{s.title}</Typography>
                        <Typography sx={{fontSize: '13px', color: '#6B7280', lineHeight: 1.6}}>{s.body}</Typography>
                        {i < READINESS_STEPS.length - 1 && (
                            <Typography sx={{
                                display: {xs: 'none', md: 'block'}, position: 'absolute', right: -14, top: '50%',
                                transform: 'translateY(-50%)', color: '#CBD5E1', fontSize: '22px', fontWeight: 800, zIndex: 1,
                            }}>
                                &rsaquo;
                            </Typography>
                        )}
                    </Box>
                </Grid>
            ))}
        </Grid>

        <NoteBanner text="* COS Reassessment is available upon request in the next COS cycle."/>
    </Box>
);

// P1 only (see PartnerDashboardList). /partner-dashboard/overview redirects
// here for every plan, so a P0 partner is sent on to their first intro page —
// the same rule as the School dashboard's page.
const AboutReadinessSolutionPage = () => {
    const { authUser } = useContext(AuthContext);
    if (getPlanStage(authUser) === 'P0') {
        return <Redirect to="/dq_pro/partner-dashboard/overview/about-assessment"/>;
    }
    return (
        <TabbedOverviewPage
            skipNoDataGate
            tabs={[
                {
                    label: 'How the COS Readiness Solution Works',
                    content: <ReadinessSolutionSection/>,
                },
            ]}
        />
    );
};

export default AboutReadinessSolutionPage;
